<template>
  <div class="top mt-5">
    <div class="container">
      <multiselect
        v-model="selectedSession"
        deselect-label="セッションを選んでください。"
        track-by="eventId"
        label="eventTitle"
        placeholder="過去のセッションを選択"
        :options="historySessions"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
      ></multiselect>
      <div class="mt-2">
        <finIinest :selectedSession="selectedSession.eventId" />
      </div>
      <tabs pills class="flex-column flex-md-row">
        <card shadow>
          <tab-pane key="tab1">
            <template slot="title">
              <i class="fa fa-comment-o mr-2"></i>HOME
            </template>
            <finChat :selectedSession="selectedSession.eventId" />
          </tab-pane>

          <tab-pane key="tab3">
            <template slot="title">
              <i class="ni ni-like-2 mr-2"></i>
              いいね！
            </template>
            <finFromIine :selectedSession="selectedSession.eventId" />
          </tab-pane>
        </card>
      </tabs>
      <div class="mt-2">
        <finSession :selectedSession="selectedSession.eventId" />
      </div>
    </div>
    <footer class="fixed-bottom p-1"></footer>
  </div>
</template>
<script>
import finChat from "./components/finChat";
import finishedEvent from "./components/finishedEvent";
import finIinest from "./components/finIinest";
import finFromIine from "./components/finFromIine";
import finSession from "./components/finSession";
import Landing from "./Landing";
import firebase from "firebase";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import Multiselect from "vue-multiselect";

//window.onbeforeunload = function(e) {
//    e.returnValue = "ページを離れようとしています。よろしいですか？";}
export default {
  components: {
    Tabs,
    finIinest,
    finFromIine,
    TabPane,
    finChat,
    finSession,
    finishedEvent,
    Multiselect
  },
  data() {
    return {
      isAuth: false,
      user: {},
      historySessions: [],
      selectedSession: {}
    };
  },
  created() {
    firebase
      .database()
      .ref("eventList/")
      .on("value", snapshot => {
        const rootList = snapshot.val();
        let list = [];

        Object.keys(rootList).forEach((val, key) => {
          if (rootList[val].eventStatus == "finished") {
            list.push(rootList[val]);
          }
        });
        var rlist = list.reverse();
        this.historySessions = rlist;
        this.selectedSession = rlist[0];
      });
  }
};
</script>
<style>
</style>
